
//================================================================
// FORMATA TEXTO DA MENSAGEM BASEADO NA TRIGGER
//================================================================
export function formatarMensagem(msg, tipo) {
  if (!msg) return "";

  msg = msg.replace(/\n/g, " ").trim();

  switch (tipo) {

    // VELOCIDADE
    case "velocidade": {
      const match = msg.match(
        /velocidade\s+(acima|abaixo|igual).*?:\s*(\d+).*?Limite\s*(\d+)/i
      );

      if (!match) return msg;

      const tipo = match[1].toLowerCase();
      const velocidade = match[2];
      const limite = match[3];

      if (tipo === "acima") {
        return `Excesso de velocidade: ${velocidade} km/h (limite ${limite} km/h)`;
      }

      if (tipo === "abaixo") {
        return `Velocidade abaixo do permitido: ${velocidade} km/h (limite ${limite} km/h)`;
      }

      if (tipo === "igual") {
        return `Velocidade igual ao limite: ${velocidade} km/h`;
      }

      return msg;
    }

    // BATERIA
    case "bateria": {
      // pega valor depois de ":"
      const match = msg.match(/:\s*(\d+(\.\d+)?)/);
      if (!match) return msg;

      const valor = parseFloat(match[1]);
      const tensao = valor % 1 === 0 ? valor : valor.toFixed(2);

      if (/alta tensão/i.test(msg)) {
        return `Bateria alta: ${tensao}v`;
      }

      if (/baixa tensão/i.test(msg)) {
        return `Bateria baixa: ${tensao}v`;
      }

      if (/falha|falta/i.test(msg)) {
        return `Falha na alimentação: ${tensao}v`;
      }

      return `Bateria: ${tensao}v`;
    }

    //  IGNIÇÃO
    case "ignicao": {
      if (/\bdesligado\b/i.test(msg)) {
        return "Ignição desligada";
      }

      if (/\bligado\b/i.test(msg)) {
        return "Ignição ligada";
      }

      return msg;
    }

    //  RPM
    case "rpm": {
      const match = msg.match(/rota.*?(\d+)/i);
      if (!match) return msg;

      return `Excesso de rotação: ${match[1]} RPM`;
    }

    // EMERGÊNCIA
    case "emergencia":
      return "Parada de emergência acionada";

    // TEMPO PARADO
    case "excesso_tempo_parado":
      return "Veículo parado por muito tempo";

    //  TEMPERATURA
    case "temperatura": {
      const match = msg.match(/(\d+)\s*C/i);
      if (!match) return msg;

      if (/acima/i.test(msg)) {
        return `Temperatura alta: ${match[1]}°C`;
      }

      if (/abaixo/i.test(msg)) {
        return `Temperatura baixa: ${match[1]}°C`;
      }

      return `Temperatura: ${match[1]}°C`;
    }

    //  ÁREA
    case "area":
      if (/entrou/i.test(msg)) return "Entrou na área";
      if (/saiu/i.test(msg)) return "Saiu da área";
      return msg;

    //  ENTRADAS
    case "entrada":
      if (/ligada/i.test(msg)) return "Entrada ligada";
      if (/desligada/i.test(msg)) return "Entrada desligada";
      return msg;

    default:
      return msg;
  }
}

//================================================================
// FORMATA O TIPO DO ALERTA (LABEL)
//================================================================
export function formatarTipo(tipo) {
  switch (tipo) {
    case "velocidade":
      return "Velocidade";

    case "excesso_tempo_parado":
      return "Excesso Tempo Parado";

    case "bateria":
      return "Bateria";

    case "ignicao":
      return "Ignição";

    case "rpm":
      return "RPM";
      
    case "emergencia":
      return "Emergência";

    default:
      return tipo || "Desconhecido";
  }
}